export default __webpack_public_path__ + "5d807cf236c139fbbba42662e57fd7d7.gif";